import { render } from "./AlertBubble.vue?vue&type=template&id=b183b440&scoped=true&ts=true"
import script from "./AlertBubble.vue?vue&type=script&lang=ts"
export * from "./AlertBubble.vue?vue&type=script&lang=ts"

import "./AlertBubble.vue?vue&type=style&index=0&id=b183b440&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b183b440"]])

export default __exports__